/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { uniqueId, orderBy } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { AsyncCreatable } from 'react-select';
import { removeTimeZoneFromDate } from 'utils/dateUtil';

import { makeSelectFnolReportDateValidation, makeSelectAppClaimType, makeSelectValidationDateErrorMessage } from '../../App/selectors';
import { makeSelectStep12 } from '../../FastCover/Step12/selectors';
import { setSelectedPolicyId, setErrorMessageDateValidation } from '../../App/actions';
import { makeSelectStep5, makeSelectCountryList, makeSelectCityList, makeSelectClaimTypeList } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import MySelect from '../../../components/MySelect';
import {
  handleFormDataChange,
  resetFormClaimToInjuryState,
  resetDetailOfMedicalConditional,
  getCityList,
  getClaimTypes,
  checkValidationDateOfEvent,
} from './actions';
import { setAuthenticationToken } from '../../Login/actions';
import { getCountryList } from './actions';
import DatePicker from '../components/DatePicker/index';
import TimePickerInput from '../../../components/TimePickerInput';
import TextArea from '../components/TextArea';
import { saveFormData } from '../actions';
import { required, checkEventDate, checkEventTime } from '../../../utils/validation/validator';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import injectSaga from '../../../utils/injectSaga';
import saga from './saga';
import FNOLTooltip from '../../../components/FNOLTooltip';
import Asterisk from '../../../components/Asterisk';
import HelpText from '../../../components/HelpText';
import {
  step6ExpenseLookup,
  step7ExpenseLookup,
  step8ExpenseLookup,
  step9ExpenseLookup,
  step10ExpenseLookup,
  step11ExpenseLookup,
} from '../dataMapper/claimCodeMapper';
import { resetFormData as resetFormDataStep6 } from '../Step6/actions';
import { resetFormData as resetFormDataStep7 } from '../Step7/actions';
import { resetFormData as resetFormDataStep8 } from '../Step8/actions';
import { resetFormData as resetFormDataStep9 } from '../Step9/actions';
import { resetFormData as resetFormDataStep10 } from '../Step10/actions';
import { resetFormData as resetFormDataStep11 } from '../Step11/actions';
import { removeFileSuccess } from '../Step12/actions';
import { redirectTo } from '../../PrivateRoute/actions';
import routeConfig from '../../../utils/routeConfig';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import EventDateWarning from './components/EventDateWarning';

export class Step5 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validationCounter: 0,
      timeValidateCounter: 0,
      showModal: false,
      errorMessageValidation: '',
    };
    this.validatorGroup = new ValidateGroup();

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;

    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    if (!this.props.isSummary) {
      this.props.getCountryList();
      // get city if have country
      if (this.props.form.country) {
        this.props.getCityList();
      }
      this.props.getClaimTypes();
    } else if (this.props.token) {
      this.props.setToken(this.props.token);
      this.props.getCountryList();
      this.props.setSelectedPolicyId(this.props.policyNumber);
      this.props.getClaimTypes();
    }
    if (this.props.path === '/wizard' && !this.props.submitted) {
      this.props.onFormDataSave();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }

    if (this.props.isSummary && this.props.appClaimTypes.length !== nextProps.appClaimTypes.length) {
      this.props.getClaimTypes();
    }
    if (nextProps.errorMessage.length > 0) {
      this.showModal();
      this.checkFormError();
    }
  }
  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };
  onChangeBenefit = (d, evt) => {
    const { selectedBenefits } = this.props.form;
    const selected = !!selectedBenefits && typeof selectedBenefits.toJS === 'function' ? selectedBenefits.toJS() : (selectedBenefits || []);
    let tmp = _.cloneDeep(selected);
    const target = evt.target;
    if (target.checked) {
      tmp.push(d);
    } else {
      tmp = tmp.filter((v) => v.claimTypeId !== d.claimTypeId);
      // we need to reset data when deselect
      this.resetFormData(d.claimCode);
    }
    this.props.onFormDataChange('form.selectedBenefits', tmp);
  };


  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }
    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(4);
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    this.checkFormError();

    this.props.onFormDataSave();
    this.props.next();
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  checkTimeCallBack = () => {
    this.props.checkValidationDateOfEvent('form.timeOfEvent');
  }

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    if (propertyName === 'form.dateOfEvent') {
      this.props.checkValidationDateOfEvent(propertyName);
      setTimeout(() => {
        this.setState({ timeValidateCounter: this.state.timeValidateCounter + 1 });
      }, 400);
    }
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    // this.props.makeDirty(4);
  };

  handleChangeCountry = (v) => {
    this.props.onFormDataChange(
      'form.country',
      v,
    );
    this.props.onFormDataChange(
      'form.city',
      '',
    );
    if (v) {
      this.props.getCityList();
    }
  }

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }


  loadCity = (inputValue, callback) => {
    setTimeout(() => {
      this.props.getCityList(inputValue, callback);
    }, 1000);
  };

  resetFormData = (code) => {
    const isStep6 = ((step6ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    const isStep7 = ((step7ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    const isStep8 = ((step8ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    const isStep9 = ((step9ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    const isStep10 = ((step10ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    const isStep11 = ((step11ExpenseLookup.claimCodeList).filter((d) => d.claimCode === code)).length > 0;
    if (isStep6) {
      this.props.resetFormDataStep6();
    } else if (isStep7) {
      this.props.resetFormDataStep7();
    } else if (isStep8) {
      this.props.resetFormDataStep8();
    } else if (isStep9) {
      this.props.resetFormDataStep9();
    } else if (isStep10) {
      this.props.resetFormDataStep10();
    } else if (isStep11) {
      this.props.resetFormDataStep11();
    }
    // need to remove files if uploaded
    const removedFileList = this.props.makeSelectStep12.attachDocuments.filter((d) => d.benefitCode === code);
    removedFileList.forEach((f) => {
      this.props.removeFileSuccess(f);
    });
  };


  closeModal = () => {
    this.setState({ showModal: false });
    this.props.setErrorMessageDateValidation('');
  };

  showModal = () => {
    this.setState({ showModal: true });
  };
  renderBenefitImage = (code) => {
    const isStep6 = ((step6ExpenseLookup.claimCodeList).filter((d) => d === code)).length > 0;
    const isStep7 = ((step7ExpenseLookup.claimCodeList).filter((d) => d === code)).length > 0;
    const isStep8 = ((step8ExpenseLookup.claimCodeList).filter((d) => d === code)).length > 0;
    const isStep9 = ((step9ExpenseLookup.claimCodeList).filter((d) => d === code)).length > 0;
    // const isStep10 = (Object.values(step10ExpenseLookup).filter((d) => d.claimCode === code)).length > 0;
    // const isStep11 = (Object.values(step11ExpenseLookup).filter((d) => d.claimCode === code)).length > 0;
    let src = '';
    if (isStep6) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStep7) {
      src = '/Luggage-gray.png';
    } else if (isStep8) {
      src = '/Medical-gray.png';
    } else if (isStep9) {
      src = '/Trip-Distruption-gray.png';
    } else {
      src = '/Other-gray.png';
    }
    return <img alt={'benefit logo'} className={'d-inline'} width={100} src={src} />;
  };
  renderBenefit = (isReadOnly) => {
    const { claimTypes, loading } = this.props;
    const { selectedBenefits } = this.props.form;
    const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
    const check = (d) => list.filter((m) => d.codeList.indexOf(m.claimCode) > -1).length > 0;
    const claimTypeList = !!claimTypes && (typeof claimTypes.toJS === 'function') ? claimTypes.toJS() : claimTypes;
    return (
      <div className={'row'} style={{ padding: '5px' }}>
        {!!claimTypeList && claimTypeList.length > 0 && orderBy(claimTypeList, ['position'], ['asc']).map((d) => (
          <div
            className={'col-sm-6'}
            key={d.claimTypeId}
          >
            <label
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: check(d) ? '2px solid #44b4a6' : '1px solid #e6e6e6',
                padding: '15px',
                backgroundColor: '#f0f4f7',
                cursor: (isReadOnly || loading) ? 'not-allowed' : 'pointer',
              }}
              className={'checkbox-container'}
            >
              <div>
                <div className={'d-flex flex-row justify-content-center align-items-center'}>
                  <div>
                    {this.renderBenefitImage(d.claimCode)}
                  </div>
                  <div
                    className={'d-inline font-weight-bold'}
                    style={{ fontSize: '0.7em', paddingLeft: '15px', lineHeight: '1.5em' }}
                  >
                    {d.description}
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <input
                  disabled={isReadOnly || loading}
                  value={d.claimTypeId}
                  onChange={this.onChangeBenefit.bind(this, d)}
                  type="checkbox"
                  checked={check(d)}
                />
                <span className="checkmark"></span>
              </div>
            </label>
          </div>
        ))}
      </div>
    );
  };
  render() {
    const dateOfEventTooltipContent = "'Date of Event' is the date that the incident occurred. If multiple incidents <br/> have occurred, each event will need its own claim.";
    const timeOfEventTooltipContent = "'Time of Event' is the time that <br/> the incident occurred.";
    const countryTooltipContent = "'Country' is the country where the incident occurred.";
    const cityTooltipContent = "'City' is the city where the incident occurred.";
    const {
      isSummary,
      submitted,
      loading,
      countryList,
      cityList,
      fnolReportDateValidationStatus,
    } = this.props;
    const {
      dateOfEvent,
      timeOfEvent,
      country,
      city,
      storyEvent,
      // totalAmount,
      selectedBenefits,
      dateBookedTrip,
      dateScheduledToDepart,
      dateOriginallyScheduled,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;
    const canMoveNext = !!dateOfEvent && !!timeOfEvent;
    const newTimeOfEvent = timeOfEvent ? moment(timeOfEvent) : null;
    const checkDate = checkEventDate(timeOfEvent);
    const checkTime = checkEventTime(dateOfEvent);
    const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
    return (
      <div className="app-content">
        <div className={'row'}>
          <div
            className={'col-sm-6 col-md-4 form-group'}
            style={{
              flexGrow: 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <PageSectionHeader>
              <FormattedMessage {...messages.dateBookedTrip} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              name="dateBookedTrip"
              type="text"
              onDayChange={this.handleDayChange('form.dateBookedTrip')}
              value={dateBookedTrip}
              placeholder=""
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateScheduledToDepart} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateScheduledToDepart"
              type="text"
              onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
              value={dateScheduledToDepart}
              placeholder=""
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOriginallyScheduled} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateOriginallyScheduled"
              type="text"
              onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
              value={dateOriginallyScheduled}
              placeholder=""
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            {fnolReportDateValidationStatus === true && <Validate
              name="dateOfEvent"
              validators={[required, checkDate]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              timeValidateCounter={this.state.timeValidateCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={dateOfEvent}
              fieldName={messages.dateOfEvent}
              tooltipDataFor={'dateOfEventHint'}
              tooltipContent={dateOfEventTooltipContent}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateOfEvent"
                type="text"
                onDayChange={this.handleDayChange('form.dateOfEvent')}
                value={dateOfEvent}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfEvent}
                />
              </ErrorMessage>
              <ErrorMessage for={checkDate}>
                <FormattedMessage
                  {...messages.checkEventDate}
                  values={messages.dateOfEvent}
                />
              </ErrorMessage>
            </Validate>
            }
            {!fnolReportDateValidationStatus && <Validate
              name="dateOfEvent"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              timeValidateCounter={this.state.timeValidateCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={dateOfEvent}
              fieldName={messages.dateOfEvent}
              tooltipDataFor={'dateOfEventHint'}
              tooltipContent={dateOfEventTooltipContent}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateOfEvent"
                type="text"
                onDayChange={this.handleDayChange('form.dateOfEvent')}
                value={dateOfEvent}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfEvent}
                />
              </ErrorMessage>
            </Validate>
            }
          </div>
          <div className={'form-group col-sm-6'}>
            {fnolReportDateValidationStatus === true && <Validate
              name="timeOfEvent"
              validators={[required, checkTime]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={newTimeOfEvent}
              fieldName={messages.timeOfEvent}
              tooltipContent={timeOfEventTooltipContent}
              tooltipDataFor={'timeOfEventHint'}
            >
              <TimePickerInput
                cb={this.checkTimeCallBack}
                allowEmpty
                showSecond={false}
                onChange={this.onChange('form.timeOfEvent')}
                value={newTimeOfEvent}
                disabled={isReadOnly}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.timeOfEvent}
                />
              </ErrorMessage>
              <ErrorMessage for={checkTime}>
                <FormattedMessage
                  {...messages.checkEventTime}
                  values={messages.timeOfEvent}
                />
              </ErrorMessage>
            </Validate>}
            {!fnolReportDateValidationStatus && <Validate
              name="timeOfEvent"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={newTimeOfEvent}
              fieldName={messages.timeOfEvent}
              tooltipContent={timeOfEventTooltipContent}
              tooltipDataFor={'timeOfEventHint'}
            >
              <TimePickerInput
                cb={this.checkTimeCallBack}
                allowEmpty
                showSecond={false}
                onChange={this.onChange('form.timeOfEvent')}
                value={newTimeOfEvent}
                disabled={isReadOnly}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.timeOfEvent}
                />
              </ErrorMessage>
            </Validate>}
          </div>
          <div className={'col-sm-12'}>
            <HelpText>Only one event can be allocated to a claim. If you are claiming for multiple events please submit one claim for each incident.</HelpText>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <Validate
              name="country"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={country}
              fieldName={messages.country}
              tooltipContent={countryTooltipContent}
              tooltipDataFor={'countryHint'}
            >
              <MySelect
                dataList={countryList}
                name="country"
                disabled={isReadOnly}
                onChange={(v) => {
                  this.handleChangeCountry(v);
                }}
                value={country}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.country}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.city} />&nbsp;<FNOLTooltip dataFor={'cityHint'} content={cityTooltipContent} />
            </PageSectionHeader>
            <AsyncCreatable
              loadOptions={this.loadCity}
              name="city"
              className="react-select-container"
              classNamePrefix="react-select"
              styles={{
                input: (styles) => ({ ...styles, border: 'none !important' }),
              }}
              value={!!city && (typeof city.toJS === 'function') ? city.toJS() : city}
              placeholder="Type a city"
              isClearable
              isDisabled={!country || isReadOnly}
              onChange={(e) => {
                this.props.onFormDataChange(
                  'form.city',
                  e,
                );
              }}
              defaultOptions={cityList && (typeof cityList.toJS === 'function') ? cityList.toJS() : (cityList || [])}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col'}>
            <Validate
              name="storyEvent"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={storyEvent}
              fieldName={messages.storyEvent}
            >
              <TextArea
                disabled={isReadOnly}
                name="storyEvent"
                type="text"
                onChange={this.handleChange('form.storyEvent')}
                value={storyEvent}
                isSummary={isSummary}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.storyEvent}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {!canMoveNext && <div className={'row'}>
          <div className={'col-sm-12 text-center'}>
            <span className="font-weight-bold">You must enter event date and time to continue.</span>
          </div>
        </div>}
        {canMoveNext && <PageSectionHeader><FormattedMessage {...messages.benefitInstruction} />&nbsp;<Asterisk /> </PageSectionHeader>}
        {canMoveNext && this.renderBenefit(isReadOnly)}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={() => {
                      redirectTo(routeConfig.claimList);
                    }}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                    disabled={submitted ? false : (!canMoveNext || !list.length)}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <EventDateWarning
          errorMessage={this.props.errorMessage}
          isOpen={this.state.showModal}
          onClose={this.closeModal}
        />
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

Step5.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  // onResetClaimToInjuryState: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  adjust: PropTypes.func,
  loading: PropTypes.bool,
  // onResetDetailOfMedicalConditional: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  step: PropTypes.number,
  fnolReportDateValidationStatus: PropTypes.any,
  countryList: PropTypes.any,
  cityList: PropTypes.any,
  getCountryList: PropTypes.func,
  getCityList: PropTypes.func,
  setToken: PropTypes.func,
  token: PropTypes.any,
  claimTypes: PropTypes.any,
  selectedBenefits: PropTypes.any,
  getClaimTypes: PropTypes.func,
  resetFormDataStep6: PropTypes.func,
  resetFormDataStep7: PropTypes.func,
  resetFormDataStep8: PropTypes.func,
  resetFormDataStep9: PropTypes.func,
  resetFormDataStep10: PropTypes.func,
  resetFormDataStep11: PropTypes.func,
  setSelectedPolicyId: PropTypes.func,
  removeFileSuccess: PropTypes.func,
  makeSelectStep12: PropTypes.any,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  policyNumber: PropTypes.any,
  path: PropTypes.any,
  errors: PropTypes.any,
  isReadOnly: PropTypes.any,
  appClaimTypes: PropTypes.array,
  errorMessage: PropTypes.string,
  checkValidationDateOfEvent: PropTypes.func,
  setErrorMessageDateValidation: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStep5(),
  loading: makeSelectProgressBarStatus(),
  fnolReportDateValidationStatus: makeSelectFnolReportDateValidation(),
  countryList: makeSelectCountryList(),
  cityList: makeSelectCityList(),
  claimTypes: makeSelectClaimTypeList(),
  makeSelectStep12: makeSelectStep12(),
  currentStep: makeSelectCurrentStep(),
  appClaimTypes: makeSelectAppClaimType(),
  errorMessage: makeSelectValidationDateErrorMessage(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onResetClaimToInjuryState: () => dispatch(resetFormClaimToInjuryState()),
  onResetDetailOfMedicalConditional: () =>
    dispatch(resetDetailOfMedicalConditional()),
  getCountryList: () => dispatch(getCountryList()),
  getCityList: (stringCity, callback) => dispatch(getCityList(stringCity, callback)),
  setToken: (t) => dispatch(setAuthenticationToken(t)),
  getClaimTypes: () => dispatch(getClaimTypes()),
  resetFormDataStep6: () => dispatch(resetFormDataStep6()),
  resetFormDataStep7: () => dispatch(resetFormDataStep7()),
  resetFormDataStep8: () => dispatch(resetFormDataStep8()),
  resetFormDataStep9: () => dispatch(resetFormDataStep9()),
  resetFormDataStep10: () => dispatch(resetFormDataStep10()),
  resetFormDataStep11: () => dispatch(resetFormDataStep11()),
  setSelectedPolicyId: (policyId) => dispatch(setSelectedPolicyId(policyId)),
  removeFileSuccess: (f) => dispatch(removeFileSuccess(f)),
  checkValidationDateOfEvent: (fieldName) => dispatch(checkValidationDateOfEvent(fieldName)),
  setErrorMessageDateValidation: (message) => dispatch(setErrorMessageDateValidation(message)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
const withReducer = injectReducer({ key: 'step5', reducer });
const withSaga = injectSaga({ key: 'step5', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect
)(Step5);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/index.js